module.exports = __webpack_public_path__ + "static/media/woman-gym.dc141b1d.png";